let timer = null
export default {
  data () {
    return {

    }
  },
  methods: {
    countDown (item) {
      function addZero (i) {
        if (i < 10) {
          i = '0' + i
        } return i
      }
      let totalSeconds = this.judgeTime(item)
      if (totalSeconds <= 0) {
        item.countDown.d = 0
        item.countDown.h = 0
        item.countDown.m = 0
        item.countDown.s = 0
      } else {
        let d = parseInt(totalSeconds / (24 * 60 * 60))
        let h = parseInt(totalSeconds / (60 * 60) % 24)
        let m = parseInt(totalSeconds / 60 % 60)
        let s = parseInt(totalSeconds % 60)
        item.countDown.d = d
        item.countDown.h = addZero(h)
        item.countDown.m = addZero(m)
        item.countDown.s = addZero(s)
        timer = setTimeout(() => {
          item.now_time += 1
          this.countDown(item)
        }, 1000)
      }
    }
  },
  beforeDestory () {
    clearTimeout(timer)
  }
}
